import { render, staticRenderFns } from "./Giro.vue?vue&type=template&id=0e94e1df&scoped=true&"
import script from "./Giro.vue?vue&type=script&lang=js&"
export * from "./Giro.vue?vue&type=script&lang=js&"
import style0 from "./Giro.vue?vue&type=style&index=0&id=0e94e1df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e94e1df",
  null
  
)

export default component.exports